import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';

import App from './App.vue';
import router from './router';
import { queryClient } from './platform/query/queryClient';
import { useAuthStore } from '@/stores/auth.store';

// Order matters: tokens.css defines the custom properties, global.css uses
// them for the base layer, and only then can Tailwind's utilities resolve
// their var() references.
import './styles/tokens.css';
import './styles/global.css';
import './styles/tailwind.css';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(VueQueryPlugin, { queryClient });

/**
 * Turns a 401 anywhere in the app into a redirect.
 *
 * lib/api.ts clears the session on a 401 and stores/auth.store.ts registers the
 * handler that does it; this watches the result. Keeping it here rather than in
 * the store avoids a circular import between the store and the fetch layer.
 */
const auth = useAuthStore(pinia);
auth.$subscribe((_mutation, state) => {
  if (state.token || router.currentRoute.value.meta.public) return;
  void router.replace({
    name: 'login',
    query: { redirect: router.currentRoute.value.fullPath },
  });
});

app.mount('#app');
